<template>
  <div>
    <bulk-upload-full-text-pdf-dialog
      v-model="showingUploadDialog"
      :exporting="exporting"
      @upload="onUpload"
      @export-references="onExport"
    />
    <bulk-upload-progress-dialog
      v-model="showingProgressDialog"
      :xml-file-name="xmlFileName"
      :zip-file-name="zipFileName"
      :xml-file-progress="xmlFileProgress"
      :zip-file-progress="zipFileProgress"
      :processing="processing"
      @cancel="cancel"
    />
    <bulk-upload-result-dialog
      v-model="showingResultDialog"
      :number-of-matched="numberOfMatched"
      :number-of-unmatched="numberOfUnmatched"
      :number-of-invalid="numberOfInvalid"
      :number-of-no-pdf="numberOfNoPdf"
      :number-of-failed-uploads="numberOfFailedUploads"
      :error="error"
      @start-review="onStartReview"
    />
  </div>
</template>

<script>
import BulkUploadFullTextPdfDialog from './BulkUploadFullTextPdfDialog';
import BulkUploadProgressDialog from './BulkUploadProgressDialog';
import BulkUploadResultDialog from './BulkUploadResultDialog';
import { Review } from '@/models';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BulkUploadFullTextPdfController',
  components: {
    BulkUploadFullTextPdfDialog,
    BulkUploadProgressDialog,
    BulkUploadResultDialog,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      showingWorkflow: 'bulkUploadFullTextPdf/showingWorkflow',
      awaitingUpload: 'bulkUploadFullTextPdf/awaitingUpload',
      uploading: 'bulkUploadFullTextPdf/uploading',
      processing: 'bulkUploadFullTextPdf/processing',
      complete: 'bulkUploadFullTextPdf/complete',
      xmlFileName: 'bulkUploadFullTextPdf/xmlFileName',
      zipFileName: 'bulkUploadFullTextPdf/zipFileName',
      xmlFileProgress: 'bulkUploadFullTextPdf/xmlFileProgress',
      zipFileProgress: 'bulkUploadFullTextPdf/zipFileProgress',
      results: 'bulkUploadFullTextPdf/results',
      error: 'bulkUploadFullTextPdf/error',
      exporting: 'bulkUploadFullTextPdf/exporting',
    }),
    showingUploadDialog: {
      get: function () {
        return this.showingWorkflow && this.awaitingUpload;
      },
      set: function (value) {
        if (!value) {
          this.cancel();
        }
      },
    },
    showingProgressDialog() {
      return (
        this.showingWorkflow && (this.uploading || this.processing)
      );
    },
    showingResultDialog: {
      get: function () {
        return this.showingWorkflow && this.complete;
      },
      set: function (value) {
        if (!value) {
          this.cancel();
        }
      },
    },
    numberOfMatched() {
      return (this.results || {}).matchedCount || 0;
    },
    numberOfUnmatched() {
      return (this.results || {}).unmatchedCount || 0;
    },
    numberOfInvalid() {
      return (this.results || {}).invalidCount || 0;
    },
    numberOfNoPdf() {
      return (this.results || {}).noPdfCount || 0;
    },
    numberOfFailedUploads() {
      return (this.results || {}).failedUploadCount || 0;
    },
  },
  methods: {
    ...mapActions({
      exportReferences:
        'bulkUploadFullTextPdf/exportReferencesMissingFullText',
      uploadFiles: 'bulkUploadFullTextPdf/uploadFiles',
      cancel: 'bulkUploadFullTextPdf/cancelWorkflow',
    }),
    onExport() {
      this.exportReferences(this.review.id);
    },
    onUpload({ xmlFile, zipFile }) {
      this.uploadFiles({
        reviewId: this.review.id,
        xmlFile,
        zipFile,
      });
    },
    onStartReview() {
      this.$router.push(`/review/${this.review.id}/full-text-review`);
    },
  },
};
</script>
